import React, { useState } from "react"
import axios from "axios"
import { useTranslation } from "react-i18next"
import MuiAlert from "@material-ui/lab/Alert"
import { SnackbarProvider } from "notistack"

import { Button, makeStyles, Snackbar } from "@material-ui/core"

import BookIcons2 from "../../static/images/Icons/book-icons2.svg"

const windowGlobal = typeof window !== "undefined" && window

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: 10,
    color: "#003e96",
    fontWeight: 600,
  },
  BookImageIcons: {
    height: 38,
  },
}))

const Favorite = id => {
  const [t] = useTranslation()
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const [openNotLoggedIn, setOpenNotLoggedIn] = useState(false)

  const classes = useStyles()

  let jwtForProfile
  if (windowGlobal) {
    jwtForProfile = windowGlobal.sessionStorage.getItem("jwtCode")
  }

  const handleAddFavorite = () => {
    if (jwtForProfile) {
      axios
        .post(
          `${process.env.GATSBY_API_URL}/addFavBook`,
          { id },
          {
            headers: { Authorization: `Bearer ${jwtForProfile}` },
          }
        )
        .then(res => {
          setOpenSnackbar(true)
          setTimeout(() => {
            setOpenSnackbar(false)
          }, 3000)
        })
    } else {
      setOpenNotLoggedIn(true)
      setTimeout(() => {
        setOpenNotLoggedIn(false)
      }, 1600)
    }
  }

  const handleCloseAddToCard = reason => {
    if (reason === "clickaway") {
      return
    }
    setOpenSnackbar(false)
  }

  const handleCloseLoginSnack = reason => {
    if (reason === "clickaway") {
      return
    }
    setOpenNotLoggedIn(false)
  }

  return (
    <>
      <Button
        variant="contained"
        color="default"
        onClick={handleAddFavorite}
        className={classes.button}
        startIcon={
          <img className={classes.BookImageIcons} alt="book" src={BookIcons2} />
        }
      >
        {t("favorite.addToFavorite")}
      </Button>
      <SnackbarProvider maxSnack={3}>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleCloseAddToCard}
        >
          <Alert onClose={handleCloseAddToCard} severity="success">
            {t("favorite.addedToFavorite")}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openNotLoggedIn}
          autoHideDuration={6000}
          onClose={handleCloseLoginSnack}
        >
          <Alert onClose={handleCloseLoginSnack} severity="error">
            {t("book.signInToContinue")}
          </Alert>
        </Snackbar>
      </SnackbarProvider>
    </>
  )
}

export default Favorite
